
module.exports = [
    {
        path:'/',
        name: 'index',
        component: require('../views/index.vue'),
        meta:{
            title:'首页',
        }
    },

    {
        path:'/news',
        name:'news',
        component:require('../views/article-list.vue'),
        meta:{
            title:'知识'
        }
    },

    {
        path:'/news/detail',
        name:'news-detail',
        component:require('../views/article-detail'),
        meta:{
            title:'知识详情'
        }
    },

    {
        path:'/me/edit',
        name:'me-edit',
        component:require('../views/profile-edit'),
        meta:{
            title:'我的'
        },
    },

    {
        path:'/me',
        name:'me',
        component:require('../views/me.vue'),
        meta:{
            title:'我的'
        }
    },

    {
        path:'/survey/detail',
        name:'survey-detail',
        component:require('../views/survey-detail.vue'),
        meta:{
            title:'问卷'
        }
    },

    {
        path:'/survey/list',
        name:'survey-list',
        component:require('../views/survey-list.vue'),
        meta:{
            title:'问卷'
        }
    },


    {
        path:'/survey/result',
        name:'survey-result-list',
        component:require('../views/survey-result-list.vue'),
        meta:{
            title:'问卷结果'
        }
    },

    {
        path:'/survey/result/detail',
        name:'survey-result-detail',
        component:require('../views/survey-result-detail.vue'),
        meta:{
            title:'问卷结果'
        }
    },




    {
        path:'/test',
        name: 'test',
        component: require('../views/test.vue'),
        meta:{
            title:'test',
        }
    },

    {
        path:'/login',
        name: 'login',
        component: require('../views/login.vue'),
        meta:{
            title:'登陆',
            auth:false,
        }
    },
    {
        path:'/register',
        name: 'register',
        component: require('../views/register.vue'),
        meta:{
            title:'注册',
            auth:false,
        }
    },
    {
        path:'/logout',
        name: 'logout',
        component: require('../views/logout.vue'),
        meta:{
            title:'logout',
            auth:false
        }
    },


    {
        path:'*',
        redirect:'/'
    }
]


// WEBPACK FOOTER //
// src/router/route.js